import { Empresa } from 'service/api'

import { CreateSlice } from './index'

export type CompanyState = {
    companyId: number
    company: Empresa | null
    setCompanyId: (id: number) => void
}

export const createCompanySlice: CreateSlice<CompanyState> = set => ({
    companyId: -1,
    company: null,
    setCompanyId: (id: number) =>
        set({
            company: null,
            companyId: id,
            employeeId: -1,
            employee: null,
            locationId: -1,
            location: null,
            costCenterId: -1,
            costCenter: null,
        }),
})
